import EpisodeInfo from './EpisodeInfo';

export default EpisodeInfo;
